import { FormattedMessage } from "react-intl";
import { clsx } from "clsx";

export default function DefaultError({ className }: { className?: string }) {
  return (
    <div className={clsx("vst-inline-alert", className)}>
      <FormattedMessage defaultMessage="Something went wrong. Please try again later." />
    </div>
  );
}
